import { useTranslation } from 'react-i18next';
import { DASHBOARD_URL } from '../env';

const tierKeys = [
  { key: 'pricing.starter', href: `${DASHBOARD_URL}/register`, highlighted: false, vars: { projects: 3, keys: 500, locales: 3 } },
  { key: 'pricing.pro', href: `${DASHBOARD_URL}/register`, highlighted: true, vars: { projects: 15, keys: 2500, locales: 15 } },
  { key: 'pricing.custom', href: '#', highlighted: false, vars: {} },
];

export default function Pricing() {
  const { t, i18n } = useTranslation();
  const fmt = new Intl.NumberFormat(i18n.language);

  return (
    <section id="pricing" className="border-t border-slate-800/50 bg-slate-900/30">
      <div className="mx-auto max-w-6xl px-6 py-20 md:py-28">
        <div className="text-center">
          <h2 className="font-display text-3xl font-bold tracking-tight md:text-4xl">
            {t('pricing.heading')}
          </h2>
          <p className="mt-4 text-slate-400">
            {t('pricing.subheading')}
          </p>
        </div>

        <div className="mt-14 grid gap-8 md:grid-cols-3">
          {tierKeys.map((tier) => {
            const fmtVars = Object.fromEntries(
              Object.entries(tier.vars).map(([k, v]) => [k, typeof v === 'number' ? fmt.format(v) : v]),
            );
            const features = t(`${tier.key}.features`, fmtVars) as unknown as string[];
            const period = t(`${tier.key}.period`);
            return (
              <div
                key={tier.key}
                className={`rounded-2xl border p-6 ${
                  tier.highlighted
                    ? 'border-emerald-500/50 bg-slate-900 ring-1 ring-emerald-500/20'
                    : 'border-slate-800/80 bg-slate-900/50'
                }`}
              >
                <h3 className="font-display text-lg font-semibold">{t(`${tier.key}.name`)}</h3>
                <div className="mt-3 flex items-baseline gap-1">
                  <span className="text-3xl font-bold">{t(`${tier.key}.price`)}</span>
                  {period && (
                    <span className="text-sm text-slate-500">{period}</span>
                  )}
                </div>
                <p className="mt-2 text-sm text-slate-400">{t(`${tier.key}.description`)}</p>
                <ul className="mt-6 space-y-3">
                  {features.map((f) => (
                    <li key={f} className="flex items-start gap-2 text-sm text-slate-300">
                      <svg
                        className="mt-0.5 h-4 w-4 shrink-0 text-emerald-400"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2}
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                      </svg>
                      {f}
                    </li>
                  ))}
                </ul>
                <a
                  href={tier.href}
                  className={`mt-8 block rounded-lg px-4 py-2.5 text-center text-sm font-medium transition-colors ${
                    tier.highlighted
                      ? 'bg-emerald-500 text-slate-950 hover:bg-emerald-400'
                      : 'border border-slate-700 text-slate-300 hover:border-slate-500 hover:text-white'
                  }`}
                >
                  {t(`${tier.key}.cta`)}
                </a>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
}
